import { Link } from "react-router-dom";

const quickLinks = [
  { name: "首页", path: "/" },
  { name: "热门推荐", path: "/category/remen" },
  { name: "排行榜", path: "/#ranking" },
  { name: "关于我们", path: "/about" },
];

const categoryLinks = [
  { name: "悬疑剧", path: "/category/xuanyi" },
  { name: "古装剧", path: "/category/guzhuang" },
  { name: "都市剧", path: "/category/dushi" },
  { name: "科幻剧", path: "/category/kehuan" },
];

const helpLinks = [
  { name: "常见问题", path: "/about" },
  { name: "联系我们", path: "/about#contact" },
  { name: "用户协议", path: "/about" },
  { name: "隐私政策", path: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-background-50"></i>
              </span>
              <span className="text-xl font-bold font-heading text-background-50">
                午马影院
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              午马影院致力于为观众提供最新最全的电视剧资源。热播新剧与经典剧集一网打尽，高清流畅不缓冲，实时更新，追剧首选平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              剧集分类
            </h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              帮助中心
            </h4>
            <ul className="space-y-2.5">
              {helpLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 午马影院 wumacinema.com 版权所有
            </p>
            <p className="text-xs text-background-500">
              本站内容仅供学习交流，不存储任何视频文件
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}